module.exports = __webpack_public_path__ + "static/media/Perhimpunan Pelajar di Taiwan (PPI Taiwan).125f2314.jpg";